module.exports = __webpack_public_path__ + "static/img/agropecuaria.8362760e.png";